/**
 * Tenant Context Hook
 *
 * Provides tenant context for GraphQL queries to ensure data isolation.
 */

import { useMemo } from 'react';
import { useCookieSession } from '@bloomcode/auth';
import { useScopeContext } from '@/core/context';

export function useTenantContext() {
  const { session, isAuthenticated } = useCookieSession();
  const { currentScope } = useScopeContext();

  return useMemo(() => {
    const tenantId = session?.tenantId;
    const isValid = isAuthenticated && !!tenantId;

    if (isAuthenticated && !tenantId) {
      console.warn('[useTenantContext] Authenticated user has no tenant context.');
    }

    return {
      tenantId,
      isValid,
      scopeTenantId: currentScope.tenantId,
    };
  }, [session?.tenantId, currentScope.tenantId, isAuthenticated]);
}
